import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { CHARGE_TYPE } from '@woovi/shared';
import { BoxFlex } from '@woovi/ui';

import type { PaymentActiveCustomer_charge$key } from './__generated__/PaymentActiveCustomer_charge.graphql.ts';
import PaymentActiveCustomerPixCreditCard from './PaymentActiveCustomerPixCreditCard.tsx';

import type { ReactNode } from 'react';

type PaymentActiveCustomerProps = {
  charge: PaymentActiveCustomer_charge$key;
};
const PaymentActiveCustomer = (
  props: PaymentActiveCustomerProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentActiveCustomer_charge$key>(
    graphql`
      fragment PaymentActiveCustomer_charge on Charge {
        customer {
          name
        }
        type
        ...PaymentActiveCustomerPixCreditCard_charge
      }
    `,
    props.charge,
  );

  if (charge.type !== CHARGE_TYPE.PIX_CREDIT) {
    return (
      <BoxFlex sx={{ justifyContent: 'center' }}>
        <Typography
          sx={{ fontSize: 24, fontWeight: 'bold', textAlign: 'center' }}
        >
          {charge.customer
            ? t('{{customerName}}, how do you want to pay?', {
                customerName: charge.customer.name,
              })
            : t('How do you want to pay?')}
        </Typography>
      </BoxFlex>
    );
  }

  return <PaymentActiveCustomerPixCreditCard charge={charge} />;
};

export default PaymentActiveCustomer;
